import { render, staticRenderFns } from "./BookWidgetFrame.vue?vue&type=template&id=b048ed18&scoped=true&"
import script from "./BookWidgetFrame.vue?vue&type=script&lang=js&"
export * from "./BookWidgetFrame.vue?vue&type=script&lang=js&"
import style0 from "./BookWidgetFrame.vue?vue&type=style&index=0&id=b048ed18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b048ed18",
  null
  
)

export default component.exports